import React, { useEffect, useState, createElement } from 'react';
export const PaystackScript = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // Check if script is already loaded
    if (document.querySelector('script[src*="paystack"]')) {
      setIsLoaded(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setIsLoaded(true);
    };
    script.onerror = error => {
      console.error('Error loading Paystack script:', error);
    };
    document.body.appendChild(script);
    return () => {
      // Don't remove the script on unmount as it might be needed by other components
      // This prevents potential "stream aborted" errors when navigating
    };
  }, []);
  return null;
};